import React, { useState, useEffect } from 'react';
import DialogWrapper from '../../../../../custom-widgets/dialogs/DialogWrapper';
import { defaultLineItemRatesTableColumns, lineItemRatesTableColumnsMap } from '../config/lineItemRatesTableConfig';
import { usePaymentLineItemRates, useFixedPaymentLineItemRates } from '../PaymentLineItems.queries';
import { usePaymentLineItemConfigs } from '../PaymentLineItemConfigs.queries';
import { useEffectiveLineItemRates } from '../effective-payment-line-item-rate/EffectivePaymentLineItemRate.queries';
import DefaultToolbar from '../../../../../custom-components/Table/DefaultToolbar';
import { getUserRegion } from '../../../../../../utils';
import { Table } from '../../../../../custom-components';
import { DialogActions } from '@mui/material';
import { Button } from '@material-ui/core';
import { paymentLineItemRateToForm } from '../payment-line-item-configs-form/lineItemConfigToForm';
import { PaymentType } from '../../../../../constants/report';

const AddExistingPaymentLineItemRateDialog = ({ dialogOpen, handleClose, handleAddExistingRate, fetchAdvanceRates, fixedRatesOnly = false }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const { data: lineItemRates, isLoading } = fixedRatesOnly ? useFixedPaymentLineItemRates() : usePaymentLineItemRates();
    const { data: effectiveRates, isLoading: isLoadingEffectiveRates } = useEffectiveLineItemRates({ rateId: selectedRow, enabled: selectedRow != null });
    const { data: paymentLineItemConfigs } = usePaymentLineItemConfigs({ paymentType: PaymentType.advance, enabled: fetchAdvanceRates });
    const [lineItemRows, setLineItemRows] = useState([]);
    const region = getUserRegion();
    const lineItemRatesTableColumns = lineItemRatesTableColumnsMap[region] || defaultLineItemRatesTableColumns;

    useEffect(() => {
        if (!fetchAdvanceRates || !paymentLineItemConfigs?.length) {
            setLineItemRows(lineItemRates ?? []);
            return;
        }
        const paymentRatesOnAdvance = new Set();
        paymentLineItemConfigs
            .filter(({ payment_type }) => payment_type.includes(PaymentType.advance))
            .forEach(({ payment_rate }) => {
                payment_rate.forEach((rate) => {
                    paymentRatesOnAdvance.add(rate.toString());
                });
            });
        setLineItemRows(lineItemRates.filter(({ _id }) => paymentRatesOnAdvance.has(_id?.toString())));
    }, [paymentLineItemConfigs, lineItemRates]);

    const handleSelectionModelChange = (newSelection) => {
        if (newSelection.length === 0) {
            setSelectedRow(null);
        } else {
            setSelectedRow(newSelection[0]);
        }
    };

    const addExistingRate = () => {
        if (selectedRow && effectiveRates?.length > 0) {
            const selectedRate = lineItemRates.find((rate) => rate._id === selectedRow);
            handleAddExistingRate(paymentLineItemRateToForm(selectedRate, effectiveRates[0], lineItemRates));
            handleClose();
        }
    };

    return (
        <DialogWrapper
            Title="Select Existing Rate"
            open={dialogOpen}
            handleClose={handleClose}
            draggable
            actions={
                <ChooseExistingRateActions
                    handleClose={handleClose}
                    disabled={selectedRow == null || isLoading || isLoadingEffectiveRates}
                    handleAddExistingRate={addExistingRate}
                    // wrap
                />
            }
            // wrap
        >
            <Table
                columns={lineItemRatesTableColumns}
                rows={lineItemRows || []}
                getRowId={(row) => row._id}
                components={{ Toolbar: DefaultToolbar }}
                loading={isLoading}
                pagination
                onSelectionModelChange={handleSelectionModelChange}
                sx={{
                    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
                        display: 'none',
                    },
                }}
                // wrap
            />
        </DialogWrapper>
    );
};

const ChooseExistingRateActions = ({ handleClose, disabled, handleAddExistingRate }) => {
    return (
        <DialogActions>
            <Button variant="outlined" color="primary" onClick={handleClose}>
                Cancel
            </Button>
            <Button variant="contained" color="secondary" disabled={disabled} onClick={handleAddExistingRate}>
                Select Rate
            </Button>
        </DialogActions>
    );
};

export default AddExistingPaymentLineItemRateDialog;
